import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private profileData: BehaviorSubject<any> = new BehaviorSubject<any>({});
  constructor(private snackBar: MatSnackBar) { }

  isAuthenticated() {
    return Object.keys(this.getLocalData(environment.AUTH_NAME + "token")).length > 0;
  }

  setLocalData(key: string, data: any) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  getLocalData(key: string) {
    if (sessionStorage.getItem(key)) {
      const data: any = sessionStorage.getItem(key);
      return JSON.parse(data);
    }
    return {};
  }

  removeLocalData(key?: any) {
    if (key) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.clear();
    }
  }

  notification(message: string, isError?: boolean) {
    if (!isError) {
      this.snackBar.open(message, '', {
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['success-snackbar'],
        duration: 3000,
      });
    } else {
      this.snackBar.open(message, ' ', {
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['error-snackbar'],
        duration: 3000,
      });
    }
  }

  convertSlug(text: string) {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }

  setProfileData(data: any) {
    this.profileData.next(data);
  }

  getProfileData() {
    return this.profileData.asObservable();
  }

  stringWithDots(val: string) {
    return val.length <= 8 ? val : val.slice(0, 4) + '...' + val.slice(-4);
  }

  errorMsg(formCntrl: any) {
    let val: any = Object.keys(formCntrl);
    let fieldName: string = '';
    for (let i = 0; i < val.length; i++) {
      if (formCntrl[val[i]].errors !== null) {
        fieldName = val[i];
        val = formCntrl[val[i]];
        break;
      }
    }
    const err: any = Object.keys(val.errors);
    let msg = '';
    if (err[0] === 'required') {
      msg = `${fieldName === 'phone_no' ? 'Phone No' : fieldName.toUpperCase()
        } required`;
    } else if (err[0] === 'pattern') {
      msg = `${fieldName === 'phone_no'
        ? 'Enter a valid Phone No with 10 digit'
        : fieldName.toUpperCase() + 'Invalid format'
        }`;
    } else if (err[0] === 'minlength') {
      msg =
        fieldName.toUpperCase() +
        ' should be ' +
        val.errors.minlength.requiredLength +
        ' chracters';
    } else if (err[0] === 'maxlength') {
      msg =
        fieldName.toUpperCase() +
        ' should be ' +
        val.errors.maxlength.requiredLength +
        ' chracters';
    } else if (err[0] === 'email') {
      msg = 'Invalid email format';
    }
    return msg;
  }


}
